import { render, staticRenderFns } from "./modele-astreintes-form.vue?vue&type=template&id=3b0deb83&scoped=true"
import script from "./modele-astreintes-form.vue?vue&type=script&lang=js"
export * from "./modele-astreintes-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0deb83",
  null
  
)

export default component.exports